// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"c25cbd6f","191":"cb7c6491","277":"19d5be3f","787":"e997b618","814":"1c9d66b3","927":"8cdd826f"}[chunkId] + ".chunk.js";
};